// extracted by mini-css-extract-plugin
module.exports = {"container":"scene_container__3Xnzy","name":"scene_name__3gRLH","title":"scene_title__1iHcb","body":"scene_body__2nrv3"};